import axios from "axios";
import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import { useAddWarehouseMutation } from "../../features/api/warehouseApi";
import { toast } from "react-toastify";

const CreateWarehouse = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [wh_name, setWhName] = useState("");
  const [wh_email, setWhEmail] = useState("");
  const [wh_address, setWhAddress] = useState("");
  const [wh_location, setWhLocation] = useState("");
  const [wh_mobile, setWhMobile] = useState("");
  const [wh_web, setWhWeb] = useState("");

  const [addNewWarehouse] = useAddWarehouseMutation();
  const handleAdd = async () => {
    try {
      const data = {
        wh_name,
        wh_email,
        wh_address,
        wh_location,
        wh_mobile,
        wh_web,
      };
      const response = await addNewWarehouse(data);
      if (response?.data) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        setWhName("");
        setWhLocation("");
        setWhAddress("");
        setWhMobile("");
        setWhEmail("");
        setWhWeb("");
      } else {
        toast.error("Duplicate Error ...");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  return (
    <div>
      <span
        onClick={openModal}
        className="flex px-1 items-center text-white bg-blue-500 font-bold cursor-pointer"
      >
        <MdAdd size={24} /> Add New
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md lg:w-[600px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">Add New</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 overflow-auto w-full">
                    <input
                      type="text"
                      value={wh_name}
                      onChange={(e) => setWhName(e.target.value)}
                      className="border pl-1"
                      placeholder="Warehouse Name"
                    />
                    <input
                      type="text"
                      value={wh_location}
                      onChange={(e) => setWhLocation(e.target.value)}
                      className="border pl-1"
                      placeholder="Location"
                    />
                    <input
                      type="text"
                      value={wh_address}
                      onChange={(e) => setWhAddress(e.target.value)}
                      className="border pl-1"
                      placeholder="Address"
                    />

                    <input
                      type="text"
                      value={wh_mobile}
                      onChange={(e) => setWhMobile(e.target.value)}
                      className="border pl-1"
                      placeholder="Mobile"
                    />
                    <input
                      type="email"
                      value={wh_email}
                      onChange={(e) => setWhEmail(e.target.value)}
                      className="border pl-1"
                      placeholder="Email"
                    />
                    <input
                      type="text"
                      value={wh_web}
                      onChange={(e) => setWhWeb(e.target.value)}
                      className="border pl-1"
                      placeholder="Website"
                    />
                  </div>
                  <button
                    onClick={() => handleAdd()}
                    className="bg-green-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateWarehouse;